webpackJsonp([34526070127519],{

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Actions'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '#action-overview' },
	                  'Overview'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '#snap-selenium-actions' },
	                  'SnapTest and Selenium-only Actions'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '#full-project-generators' },
	                  'Full-project generators'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '#action-json' },
	                  'Action JSON'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: '#action-contract' },
	                  'Generator Action Contract'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Overview'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Tests are composed of a list of actions - commands to tell the browser what to do and assertions to check for.  For example, a simple test may say:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Load a page.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Check for an element to exist. '
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Click on a link. '
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This test is composed of 3 actions.  If this test succeeds, you can by nature assert these  things: The page exists and works, an element exists, and a link exists and can be clicked.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('a', { className: 'hash-tag', name: 'snap-selenium-actions' })
	            ),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'SnapTest and Selenium-only Actions'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Most actions can be executed within the extension, but due to Chrome extension limitations, some actions can only be "automated" by running the generated Selenium code (iFrames, window context switching, drag and drop).',
	              _react2.default.createElement('br', null),
	              'If an action turns "yellow" in the extension, it means that it is a Selenium only action and will need to be manually executed in the extension.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1530669724/Actions/Screen_Shot_2018-07-03_at_9.01.30_PM.png', style: { "max-width": "400px" } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              'Selenium-only actions played within the extension will soon get "pause and wait for manual action" feature for those who like to stay within SnapTest for running tests.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Currently, when you toggle the timeout between custom and global, it applies the global to the custom value afterwards.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' It\'s possible to restore the old value, but you\'ll have to remember what you put before and input it manually.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1529371565/teams/global-timeout.gif', style: { "max-width": "400px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This shouldn\'t be an issue if you\'re setting the custom timeout once.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A few uses cases for custom timeouts are:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Page loads.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Registration.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Submitting a purchase.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Waiting for an event to appear.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('a', { className: 'hash-tag', name: 'full-project-generators' })
	            ),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Full-project generators'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'SnapTest strives to give its users the ability to generate entire projects in various frameworks, which should just work without requiring you to adjust your tests for other frameworks.  '
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'In order to do this, project/code generators must meet the ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Generator Action Contract'
	                )
	              ),
	              ' so that the Selenium playback matches the extension playback.  For a generator to be considered a "Full-project generator", it must fulfill the following action specifications at 100%:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('a', { className: 'hash-tag', name: 'action-json' })
	            ),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Action JSON'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Each action is defined by a JSON array entry.  Each action has:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'A "description" variable that should help generate better error reports and/or add code comments.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'A "skipIfFailed" variable that should continue execution if action fails.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'A "timeout" variable.  If null, it should use the global timeout setting.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('a', { className: 'hash-tag', name: 'action-contract' })
	            ),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Generator Action Contract:'
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Navigation Commands:'
	            ),
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Action:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Type:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'w-25' },
	                    'Spec:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Variables:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Automated in:'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Load Page'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'FULL_PAGELOAD'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Perform a GET request at the url ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    ' and sets window dimensions to ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'width'
	                    ),
	                    ' & ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'height'
	                    ),
	                    '.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': String - Fully qualified url. accepts variables.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'width'
	                        ),
	                        ': Number - Window width'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'height'
	                        ),
	                        ': Number - Window height'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Back'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'BACK'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Performs a "back" operation, same as clicking the back button in a browser.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'None'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Forward'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'FORWARD'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Performs a "forward" operation, same as clicking the foward button in a browser.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'None'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Refresh'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'REFRESH'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Performs a soft "refresh" operation, meaning no cache\'s are getting cleared.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'None'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Focus window'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'CHANGE_WINDOW'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Changes the test "focus" or "context" to index ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '. Initial tab/window is 0, and any additional windows are incrementally numbered by the order they\'re opened.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': Number - Index of the window to be focused. '
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Selenium-only'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              'General Commands:'
	            ),
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Action:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Type:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'w-25' },
	                    'Spec:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Variables:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Automated in:'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Click element'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'MOUSEDOWN'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. performs a full click on that element.',
	                    _react2.default.createElement('br', null),
	                    '    '
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'x'
	                        ),
	                        ': Number - (optional use) the X coord of the click.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'y'
	                        ),
	                        ': Number - (optional use) the Y coord of the click.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Press key...'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'KEYDOWN'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. Sends a key press signal to an element with the ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'keyValue'
	                    ),
	                    ' keycode.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'keyValue'
	                        ),
	                        ': String ("Enter" or "Escape")'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Selenium-only'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Change input...'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'INPUT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. Fully replace the element\'s value with ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '.',
	                    _react2.default.createElement('br', null),
	                    '    '
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': String - New value to replace the old value with. (should accept variables)'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Form submit'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'SUBMIT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. Triggers the form submit functionality on a form. Can be triggered via JS or focusing and clicking "Enter".'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector of a form.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Mouse over'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'MOUSEOVER'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. Simulate a user mousing over the element.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Selenium-only'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Focus'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'FOCUS'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. Perform a focus on the element.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Blur'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'BLUR'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. Perform a blur off of the element.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector.'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Pause'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'PAUSE'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Pause test execution for ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    ' amount of milliseconds.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': Number - Amount in milliseconds to pause.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Execute script'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'EXECUTE_SCRIPT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Inject and execute the ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'script'
	                    ),
	                    ' string in the page.   May return ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'true'
	                    ),
	                    ' or ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'false'
	                    ),
	                    ' for asserting.  If returns ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'false'
	                    ),
	                    ', it should fail as an assertion.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'script'
	                        ),
	                        ': String - Javacript code to be injected.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'nowrap' },
	                    'Clear cookies'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'CLEAR_COOKIES'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Clear the cookies at domain ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '.  ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    ' must be a fully qualified url with protocol.  '
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': String - Url to clear cookies of: should be an FQDN - "',
	                        _react2.default.createElement(
	                          'a',
	                          { href: 'https://www.snaptest.io' },
	                          'https://www.snaptest.io'
	                        ),
	                        '" not "www.snaptest.io" (should accept variables)'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Scrolling Commands:'
	            ),
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Action:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Type:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'w-25' },
	                    'Spec:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Variables:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Automated in:'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Scroll win(dow) to...'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'SCROLL_WINDOW'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Scroll the window to the ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'x'
	                    ),
	                    ' and ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'y'
	                    ),
	                    ' coordinates.  Should trigger "onscroll" events.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'x'
	                        ),
	                        ': Number - the target X coord'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'y'
	                        ),
	                        ': Number - the target Y coord'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Scroll win(dow) to el(ement)...'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'SCROLL_WINDOW_ELEMENT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. Scroll the window to the element.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Scroll el(ement) to...'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'SCROLL_ELEMENT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. Scroll an element to the ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'x'
	                    ),
	                    ' / ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'y'
	                    ),
	                    ' position.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'x'
	                        ),
	                        ': Number - the target X coord'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'y'
	                        ),
	                        ': Number - the target Y coord'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Assertions:'
	            ),
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Action:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Type:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'w-25' },
	                    'Spec:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Variables:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Automated in:'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'El is present'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'EL_PRESENT_ASSERT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'El isn\'t present'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'EL_NOT_PRESENT_ASSERT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' doesn\'t exist. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null)
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'El text is...'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'TEXT_ASSERT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. If ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'regex'
	                    ),
	                    ' is ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'false'
	                    ),
	                    ', then check for the element\'s text to equal ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '. retry every second for the remaining ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' value.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '3.  If ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'regex'
	                    ),
	                    ' is ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'true'
	                    ),
	                    ', then check for the element\'s text to test positive against the regex (/',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '/g).'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': String - value to match.  if matching regex, it will be /value/g (should accept variables)'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'regex'
	                        ),
	                        ': Boolean - specifies whether this assertion should use a regex'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Input value is...'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'VALUE_ASSERT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    '1. Check that an element at ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'selector'
	                    ),
	                    ' exists. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. If ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'regex'
	                    ),
	                    ' is ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'false'
	                    ),
	                    ', then check for the inputs\'s value to equal ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '. retry every second for the remaining ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' value.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '3.  If ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'regex'
	                    ),
	                    ' is ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'true'
	                    ),
	                    ', then check for the input\'s value to test positive against the regex (/',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '/g).'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'selector'
	                        ),
	                        ': String - CSS selector'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': String - value to match.  if matching regex, it will be /value/g (should accept variables)'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'regex'
	                        ),
	                        ': Boolean - specifies whether this assertion should use a regex'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Path is...'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'PATH_ASSERT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Note: "Path" refers "/hello" in "',
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'https://www.wowow.com/hello?cool=neat#awesome' },
	                      'https://www.wowow.com/hello?cool=neat#awesome'
	                    ),
	                    '" ',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '1. DOM is ready. Retry every second for total amount of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' ms.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '2. If ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'regex'
	                    ),
	                    ' is ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'false'
	                    ),
	                    ', then check for the path\'s value to equal ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '. retry every second for the remaining ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'timeout'
	                    ),
	                    ' value.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    '3.  If ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'regex'
	                    ),
	                    ' is ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'true'
	                    ),
	                    ', then check for the path\'s value to test positive against the regex (/',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    '/g).'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': String - value to match.  if matching regex, it will be /value/g'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'regex'
	                        ),
	                        ': Boolean - specifies whether this assertion should use a regex'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'timeout'
	                        ),
	                        ': Number - MS to wait for element.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Miscellaneous:'
	            ),
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Action:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Type:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { className: 'w-25' },
	                    'Spec:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Variables:'
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    null,
	                    'Automated in:'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Component'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'COMPONENT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Call the component of ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'componentId'
	                    ),
	                    ' from the component pool.  When calling the component, pass in the ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'variable'
	                    ),
	                    ' array as the method arguments.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'componentId'
	                        ),
	                        ': String - ID of the component to execute'
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'variable'
	                        ),
	                        ': Array - Instance variables that will override the default variales of a component.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Url change indicator'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'URL_CHANGE_INDICATOR'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'A non-functional "flag" that helps in the generation of code and visual clarity in the snaptest tool.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': String - The name of the page. (auto-generated as the page - e.g. /login).'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Snaptest/Selenium'
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Take screenshot'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'SCREENSHOT'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Take a screenshot and save it with the filename ',
	                    _react2.default.createElement(
	                      'code',
	                      null,
	                      'value'
	                    ),
	                    ' in the default/configured location.'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      null,
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'code',
	                          null,
	                          'value'
	                        ),
	                        ': String - The file name and path of where the screenshot should be saved.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    'Selenium-only'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-actions-js-a6cdd9300fbd0a397351.js